export function memberIsAdmin(member?: Member | null): boolean {
  if (!member) {
    return false
  }
  return member.roles?.admin === true
}

export function memberIsBandAdmin(member?: Member | null): boolean {
  if (!member) {
    return false
  }
  return member.roles?.band_admin === true
}

export function memberIsRedshirtAdmin(member?: Member | null): boolean {
  if (!member) {
    return false
  }
  return member.roles?.redshirt_admin === true
}
